// extracted by mini-css-extract-plugin
module.exports = {"block":"VideoPopup_block__O3jsG","youtube":"VideoPopup_youtube__7cm_N","cross":"VideoPopup_cross__Ltrkf"};